import { createSelector } from '@reduxjs/toolkit'
import {
  CheckoutAppSelector,
  useAppSelector,
  useCountry,
  useInitialData,
  useInternationalShippingEnabled,
  useIsChosenShippingCountrySupported,
  useIsExpress,
  useIsPickup,
} from '..'
import { ShippingAddressState } from './reducer'
import { ShippingAddressStatus } from '../../model/shippingAddress'
import { AddressModeType } from '../../model'

export const shippingAddressSelector: CheckoutAppSelector<ShippingAddressState> = (state) => state.shippingAddress

export const hasSavedAddresses: CheckoutAppSelector<boolean> = createSelector(shippingAddressSelector, (state) => state?.allAddresses?.length > 0)

export const useShippingAddress = (): ShippingAddressState => useAppSelector(shippingAddressSelector)

export const useHasSavedAddresses = (): boolean => useAppSelector(hasSavedAddresses)

export const useIsShippingAddressValid = (): boolean => {
  const isExpress = useIsExpress()
  const isPickup = useIsPickup()
  const consumerCountry = useCountry()
  const { addressMode } = useInitialData()
  const { chosenAddress, shippingAddressStatus } = useShippingAddress()
  const internationalShippingEnabled = useInternationalShippingEnabled()
  const chosenAddressCountrySupported = useIsChosenShippingCountrySupported()

  if (!isExpress || addressMode === AddressModeType.NO_ADDRESS) {
    return true
  }
  if (isPickup) {
    return true
  }
  if (shippingAddressStatus <= ShippingAddressStatus.Initialising) {
    return false
  }
  if (internationalShippingEnabled) {
    return chosenAddressCountrySupported
  }
  if (chosenAddress?.countryCode !== consumerCountry) {
    return false
  }

  return chosenAddress !== undefined
}
